var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record-audio-container"},[(_vm.isPC)?_c('button',{staticClass:"record-btn pc",attrs:{"disabled":_vm.disabled},on:{"click":_vm.toggleRecord}},[_vm._v("\n    "+_vm._s(_vm.isListening ? "🔴 聆听中..." : "🎤")+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }